var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M31.86 6.667H8.138c-.813 0-1.472.659-1.472 1.472v23.723c0 .813.659 1.472 1.472 1.472h12.773V23.007h-3.476v-4.024h3.476v-2.969c0-3.444 2.103-5.32 5.176-5.32 1.473 0 2.737.11 3.106.16v3.6h-2.131c-1.671 0-1.995.795-1.995 1.96v2.57h3.986l-.52 4.024h-3.466v10.326h6.796c.81 0 1.47-.66 1.47-1.473V8.14c0-.814-.66-1.472-1.473-1.472Z",
    clipRule: "evenodd",
    opacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFb);
export default __webpack_public_path__ + "static/media/logo-fb.6efeb79b1d84f6450c83e049fac6b14f.svg";
export { ForwardRef as ReactComponent };